import { errorToastClassName, successToastClassName, appToast as toast } from "@/components/ui/baseUi/sonner"
import { useBoxProgram } from "@/modules/boxProgrammation/hooks/useBoxProgram"
import { BoxSlotTemplateEntity } from "@/modules/boxSlotTemplate/entities/boxSlotTemplateEntity"
import { BoxSlotTemplateFormikEntity } from "@/modules/boxSlotTemplate/entities/boxSlotTemplateFormikEntity"
import { useBoxSlotTemplateCreate, useBoxSlotTemplateUpdate } from "@/modules/boxSlotTemplate/hooks/useBoxSlotTemplates"
import { getValidationSchema } from "@modules/boxSlotTemplate/boxSlotTemplateFormikType"
import { word } from "@modules/core/utils/i18n"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { useConfirmPopup } from "@modules/ui/components/popup/huConfirmPopup"
import { useFormik } from "formik"

export const useBoxSlotTemplateFormik = (
  boxProgramId: string,
  boxSlotTemplate: BoxSlotTemplateEntity,
  isEdition: boolean,
) => {
  const { hideSidebar } = useSidebar()
  const { mutateAsync: updateBoxSlotTemplate } = useBoxSlotTemplateUpdate()
  const { mutateAsync: createBoxSlotTemplate } = useBoxSlotTemplateCreate()
  const { data: boxProgram } = useBoxProgram(boxProgramId)
  const confirmPopup = useConfirmPopup()

  const confirmEditionBoxSlotTemplate = (formikValues: BoxSlotTemplateFormikEntity) => {
    confirmPopup.show({
      title: word("programmation.slotTemplates.edition_confirmation_title"),
      message: word("programmation.slotTemplates.edition_confirmation_message"),
      accept: async () => {
        await updateBoxSlotTemplate({
          boxProgramId: boxProgram.id,
          boxSlotTemplateId: boxSlotTemplate.id,
          boxSlotTemplate: formikValues.toInputDto(),
        })
        hideSidebar()
      },
    })
  }

  const formik = useFormik<BoxSlotTemplateFormikEntity>({
    initialValues: BoxSlotTemplateFormikEntity.fromEntity(boxSlotTemplate, boxProgramId),
    validationSchema: getValidationSchema(isEdition),
    enableReinitialize: true,
    onSubmit: async () => {
      try {
        if (isEdition) {
          confirmEditionBoxSlotTemplate(formik.values)
        } else {
          await createBoxSlotTemplate({
            boxProgramId: boxProgramId,
            boxSlotTemplate: formik.values.toInputDto(),
          })
          toast.success(word("box.slotTemplate.form.toast.success"), {
            classNames: successToastClassName(),
          })
          hideSidebar()
        }
      } catch (e: unknown) {
        if (e instanceof Error) {
          toast.error(word("global.error.label"), {
            description: e.message,
            classNames: errorToastClassName(),
          })
        } else {
          toast.error(word("global.error.default"), {
            description: String(e),
            classNames: errorToastClassName(),
          })
        }
      }
    },
  })

  return formik
}
